import { render } from "./SmallCardPreloaderComp.vue?vue&type=template&id=6541fe98&scoped=true&ts=true"
import script from "./SmallCardPreloaderComp.vue?vue&type=script&lang=ts"
export * from "./SmallCardPreloaderComp.vue?vue&type=script&lang=ts"

import "./SmallCardPreloaderComp.vue?vue&type=style&index=0&id=6541fe98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6541fe98"]])

export default __exports__